'use client';
import React, { FC } from 'react';
import { cn } from '@wwe-portal/ui/lib/lib';
import { useSuperstarDetailContext } from './context';
import { CompareVFX } from '@wwe-portal/ui/features/roster/compare-vfx';

export const CompareVFXConsumer: FC<{
  className?: string;
  containerClassName?: string;
  children?: React.ReactNode;
}> = ({ className, containerClassName, children }) => {
  const compareEffect = useSuperstarDetailContext(
    (state) => state.compareEffect
  );

  return (
    <div className={cn('relative', containerClassName)}>
      {children}

      {compareEffect.isActive && (
        <CompareVFX
          className={cn('absolute inset-0', className)}
          duration={compareEffect.duration}
          from={compareEffect.from}
        />
      )}
    </div>
  );
};
